import React from 'react';
import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { getPlaceType, getBadgeColor } from '../utils';
import type { PlaceTypeBadgeProps } from '../types';
import styles from '../AddressSearchBar.module.css';

export const PlaceTypeBadge = React.memo<PlaceTypeBadgeProps>(({
  type,
  size = 'xs',
}) => {
  const { t } = useTranslation();
  const placeType = getPlaceType(type);
  const color = getBadgeColor(placeType);

  return (
    <Badge
      size={size}
      color={color}
      variant="light"
      className={styles.flexShrinkZero}
    >
      {t(`placeTypes.${placeType}`)}
    </Badge>
  );
});